/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_B21Inputs */

const en_cv_extract_form_enum_b21 = /** @type {(inputs: Cv_Extract_Form_Enum_B21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B2 - Upper Intermediate`)
};

const de_cv_extract_form_enum_b21 = /** @type {(inputs: Cv_Extract_Form_Enum_B21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B2 - Selbständige Sprachverwendung`)
};

/**
* | output |
* | --- |
* | "B2 - Upper Intermediate" |
*
* @param {Cv_Extract_Form_Enum_B21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_b21 = /** @type {((inputs?: Cv_Extract_Form_Enum_B21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_B21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_b21(inputs)
	return en_cv_extract_form_enum_b21(inputs)
});
export { cv_extract_form_enum_b21 as "cv_extract_form_enum_B2" }